import { AppIcon, AppIcons } from '@backrs_ui/common-ui/dist/designSystem/icons/AppIcon';

import { Box, SxProps, Typography, Theme } from '@mui/material';

type FilterParentRenderProps = Readonly<{
  iconName: AppIcons;
  isAnyItemSelected: boolean;
  name: string;
}>;

export const FilterParentRender = ({
  iconName,
  isAnyItemSelected,
  name,
}: FilterParentRenderProps) => {
  return (
    <Box sx={renderValueStyle}>
      <Box sx={renderValueIconStyle}>
        <AppIcon
          iconName={iconName}
          diameter="20px"
          color={isAnyItemSelected ? 'Colors/Text/text-primary' : 'Colors/Text/text-placeholder'}
        />
      </Box>
      <Typography
        variant="text-md-medium"
        color={({ backrs }) =>
          isAnyItemSelected
            ? backrs.colors['Colors/Text/text-primary']
            : backrs.colors['Colors/Text/text-placeholder']
        }
      >
        {name}
      </Typography>
      <Box sx={renderValueIconStyle}>
        <AppIcon
          iconName="ChevronDown"
          diameter="20px"
          color={isAnyItemSelected ? 'Colors/Text/text-primary' : 'Colors/Text/text-placeholder'}
        />
      </Box>
    </Box>
  );
};

const renderValueStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: backrs.spacing['spacing-md'],
  boxSizing: 'border-box',
  width: '100%',
  marginRight: backrs.spacing['spacing-md'],
});

const renderValueIconStyle: SxProps<Theme> = {
  width: '20px',
  height: '20px',
};
